module.exports = __webpack_public_path__ + "img/australianrules.129f7c95.svg";